import * as actionTypes from '../../actions/action-types.js'

const initialState = {
    usersDropDownOpen: false,
}

const ui = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FD_UI_TOGGLE_USERDROPDOWN:
            return {
                ...state,
                usersDropDownOpen: action.force,
            }
        default: {
            return state
        }
    }
}

export default ui
